import { useState, useEffect } from "react";
import axios from "axios";
import useAuthStore from "../store/authStore";

export default function HotelBookingForm() {
  const { user, token } = useAuthStore();

  const [form, setForm] = useState({
    full_name: "",
    email: "",
    phone: "",
    destination: "",
    check_in: "",
    check_out: "",
    guests: "",
    notes: "",
  });

  const [message, setMessage] = useState("");

  useEffect(() => {
    if (user) {
      setForm((prev) => ({
        ...prev,
        full_name: user.name,
        email: user.email,
      }));
    }
  }, [user]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const res = await axios.post(
      "https://backend.ysskytravel.com/api/hotel/book-hotel",
      form,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      }
    );

    setMessage(res.data.message);

    // Reset form after successful submit
    setForm({
      full_name: user ? user.name : "",
      email: user ? user.email : "",
      phone: "",
      destination: "",
      check_in: "",
      check_out: "",
      guests: "",
      notes: "",
    });

  } catch (error) {
    setMessage("Something went wrong!");
  }
};


  return (
    <div className="max-w-md mx-auto bg-white/80 backdrop-blur-md p-8 rounded-2xl shadow-xl border border-blue-200">

      <h2 className="text-3xl font-bold text-center mb-6 text-primary drop-shadow-sm">
        Hotel Booking Request
      </h2>

      {message && (
        <div className="mb-4 p-3 bg-green-100 border border-green-300 rounded-xl text-green-700 shadow-sm animate-pulse">
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">

        {!user && (
          <>
            <input
              type="text"
              name="full_name"
              placeholder="Full Name"
              value={form.full_name}
              onChange={handleChange}
              required
              className="w-full p-3 border rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all focus:shadow-blue-200"
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={form.email}
              onChange={handleChange}
              required
              className="w-full p-3 border rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all focus:shadow-blue-200"
            />
          </>
        )}

        <input
          type="text"
          name="phone"
          placeholder="Phone Number"
          value={form.phone}
          onChange={handleChange}
          required
          className="w-full p-3 border rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all focus:shadow-blue-200"
        />

        <input
          type="text"
          name="destination"
          placeholder="Destination / City"
          value={form.destination}
          onChange={handleChange}
          required
          className="w-full p-3 border rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all focus:shadow-blue-200"
        />

        <div className="flex gap-3">
          <input
            type="date"
            name="check_in"
            value={form.check_in}
            onChange={handleChange}
            required
            className="w-1/2 p-3 border rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all focus:shadow-blue-200"
          />
          <input
            type="date"
            name="check_out"
            value={form.check_out}
            onChange={handleChange}
            required
            className="w-1/2 p-3 border rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all focus:shadow-blue-200"
          />
        </div>

        <input
          type="number"
          name="guests"
          placeholder="Number of Guests"
          value={form.guests}
          onChange={handleChange}
          required
          min="1"
          className="w-full p-3 border rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all focus:shadow-blue-200"
        />

        <textarea
          name="notes"
          placeholder="Additional Notes (optional)"
          value={form.notes}
          onChange={handleChange}
          className="w-full p-3 h-24 border rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all focus:shadow-blue-200"
        />

        <button
          type="submit"
          className="
            w-full py-3 rounded-xl 
           btn-primary
            text-white font-semibold text-lg 
            shadow-lg 
            hover:shadow-blue-400 hover:brightness-110 
            transition-all duration-300
          "
        >
          Submit Request
        </button>
      </form>
    </div>
  );
}
